/**
 * Get the upcoming events list from API
 * @param {object} state
 * @return {object[]}
 */
export const getUpcomingEvents = (state) => {
  return Array.isArray(state.upcomingEvents) ? state.upcomingEvents : null
};


